import { API } from '@/redux/config/index';
import { toast } from 'react-toastify';
import {
	basicLoginSuccess,
	loginSuccess,
	logoutSuccess,
	setCurrentUserUserName,
	setLoginDetail,
	setQrUri,
	setSsoLoginFailure,
} from '../reducers/authReducer';
// Import the persistor from your store
import { getLocalStorageData, setLocalStorageData } from '../../utils/LocalStorage';
import { clearCookies, getCookies, setSessionCookie } from '../../utils/cookies';

export const LoginAction = (credentials, ssoLoginFailure, navigate, setError) => async dispatch => {
	try {
		console.log('setLoginDetail____ResetIndexed_DB');
		const initialResponse = await API.get(`/users/email/${credentials?.email}`);
		const loginTime = new Date().getTime();
		const expirationTime = loginTime + 8 * 60 * 60 * 1000;
		const enabledSso = initialResponse?.data?.enabledSso;
		setLocalStorageData('logoutTime', expirationTime);
		setLocalStorageData('loginTime', loginTime);
		setLocalStorageData('currentSiteID', 'all');
		// Go To LoginSSO Page If SSO Is Enabled And SSO Login Failure Has Not Occured Already
		if (enabledSso && !ssoLoginFailure) {
			return navigate('/loginSSO');
		}

		const response = await API.post('/auth/login', credentials, {
			withCredentials: true,
		});

		// dispatch(setCurrentSite({ value: 'all', label: 'All Sites', key: 'all' }))

		dispatch(setLoginDetail(response.data));
		if (response?.data?.bypass2FA) {
			setSessionCookie(response?.data);

			dispatch(loginSuccess(response?.data));

			if (response.data.isPrimaryContact && response.data.customerOnboarded === false) {
				return navigate('/onboarding_system');
			}
			if (response.data.redirectUrl) {
				return navigate(response.data.redirectUrl);
			} else {
				return navigate(getLocalStorageData('redirect') || '/tickets/');
			}
			// return navigate(getLocalStorageData('redirect') || '/tickets/')
		}
		if (response?.data.isLoggedInWithout2FA) {
			dispatch(setCurrentUserUserName(credentials.email));
			return navigate('/2fa');
		}
		if (response?.data?.scanQR) {
			// dispatch(loginSuccess(response?.data))
			dispatch(setCurrentUserUserName(credentials.email));
			return navigate('/2fa');
		}

		dispatch(basicLoginSuccess(response?.data));
		return navigate('/2fa');
	} catch (error) {
		if (error?.response?.status === 403) {
			dispatch(setCurrentUserUserName(credentials.email));
			return navigate('./2fa');
		}
		if (error?.response?.status === 409) {
			return navigate('/resetPassword');
		}
		toast.error(error?.response?.data?.message);

		return setError(true);
	}
};

export const Verify2faAction =
	(email, credentials, navigate, setError, initialVerify = false) =>
	async dispatch => {
		try {
			const data = { email, code: credentials?.code };
			console.log(data);
			if (initialVerify) {
				await API.post('/auth/2fa/initialverify', data);
			}
			const response = await API.post('/auth/login', data, {
				withCredentials: true,
			});
			setSessionCookie(response?.data);
			dispatch(loginSuccess(response?.data));

			console.log('Login___response:', response.data);
			if (response.data.isPrimaryContact && response.data.customerOnboarded === false) {
				return navigate('/onboarding_system');
			}
			if (response.data.redirectUrl) {
				navigate(response.data.redirectUrl);
			} else {
				navigate(getLocalStorageData('redirect') || '/tickets/');
			}
		} catch (error) {
			if (error?.response?.status === 409) {
				navigate('/resetPassword');
			}
			console.log('error', error);

			setError(true);
		}
	};

export const Enable2faAction = token => async dispatch => {
	try {
		const response = await API.post('/auth/2fa', null, {
			headers: { token: token },
		});

		dispatch(setQrUri(response?.data?.QR_uri));
	} catch (error) {
		if (error.response) {
			toast.error(error?.response?.data?.message);
		}
		dispatch(setQrUri(''));
	}
};

export const ResetPasswordEmailAction = (email, setEmailSent) => async dispatch => {
	try {
		const response = await API.post('/auth/send_reset_email', email);
		setEmailSent(true);
		toast.success(response.data);
	} catch (error) {
		if (error.response) {
			toast.error(error?.response?.data?.message);
		}
	}
};
export const Reset2faEmailAction = email => async dispatch => {
	try {
		await API.post('/auth/send_reset_otp_email', email);
	} catch (error) {
		if (error.response) {
			toast.error(error?.response?.data?.message);
		}
	}
};

export const ResetPasswordAction = (credentials, navigate) => async dispatch => {
	try {
		await API.put('/auth/reset_password', credentials);
		toast.success('Password reset successfully, please login with your new password');
		navigate('/login');
	} catch (error) {
		if (error.response) {
			toast.error(error?.response?.data?.message);
		}
	}
};

export const UpdateCredsAction = (apiToken, refreshToken) => async dispatch => {
	try {
		const response = await API.get('/auth/creds', {
			headers: { token: apiToken, refresh: refreshToken },
		});
		setSessionCookie(response?.data);
		localStorage.setItem('token', response?.data);

		dispatch(loginSuccess(response?.data));
	} catch (error) {
		if (error.response.status === 401) {
			localStorage.clear();
			sessionStorage.clear();
			window.history.pushState({}, '', '/login');
			// toast.error(error?.response?.data?.message)
		}
	}
};

export const GetSessionCreds =
	(sessionHeader, copy, navigate = null) =>
	async dispatch => {
		try {
			const sessionCookie = getCookies()?.session;
			const response = await API.get('/auth/session', {
				withCredentials: sessionCookie && sessionCookie !== sessionHeader ? false : true,
				headers: { sessionID: sessionHeader },
				params: { copy },
			});
			setSessionCookie(response?.data);
			localStorage.setItem('token', response?.data);

			dispatch(loginSuccess(response?.data));
			if (navigate) {
				navigate();
			}
		} catch (error) {
			if (error?.response?.status === 401) {
				localStorage.clear();
				sessionStorage.clear();
				window.history.pushState({}, '', '/login');
				// toast.error(error?.response?.data?.message)
			} else {
				console.log('Authentication Error', error);
			}
		}
	};

export const ClearSession = () => async dispatch => {
	try {
		const cookies = getCookies();
		const sessionCookie = cookies?.session;
		const sessionHeader = cookies?.sessionID;
		await API.post(
			'/auth/session/end',
			{},
			{
				withCredentials: sessionCookie && sessionCookie !== sessionHeader ? false : true,
				headers: { sessionID: sessionHeader },
			},
		);
	} catch (error) {
		console.log('ClearSession', error?.response?.status);
	}
};

// logout of the portal
export const LogoutAction = (email, navigate) => async dispatch => {
	try {
		const response = await API.get(`/auth/logout?email=${email}`);
		// const sloUrl = response?.data?.sloUrl
		dispatch(logout());

		localStorage.clear();
		sessionStorage.clear();
		clearCookies();
		navigate('/login');

		dispatch(logoutSuccess(response?.data));
	} catch (error) {
		localStorage.clear();
		sessionStorage.clear();
		await navigate('/login');
	}
};

// Intitialize SSO Authentication test (action not used)
// export const SSOAuthenticationTest = () => async (dispatch) => {
//   try {
//     const response = await API.post('/auth/sso/test_acs');
//   } catch (err) {
//     dispatch(setSsoLoginFailure(err));
//   }
// };

// Intitialize SSO Authentication
export const SSOAuthentication = (customerId, userId) => async dispatch => {
	try {
		const response = await API.post(`/auth/sso?customerID=${customerId}&userID=${userId}`);
		if (response?.status === 200) {
			window.location.href = response.data?.ssoUrl;
		}
	} catch (err) {
		dispatch(setSsoLoginFailure(err.response.data.detail));
	}
};

// get token from sso authentication
export const SSOAuthenticationToken = (message, signature, token, navigate) => async dispatch => {
	try {
		const response = await API.get('/auth/sso/token', {
			withCredentials: true,
			headers: {
				message: message,
				signature: signature,
			},
			params: { token },
		});

		setSessionCookie(response?.data);
		dispatch(loginSuccess(response?.data));
		const loginTime = new Date().getTime();
		const expirationTime = loginTime + 8 * 60 * 60 * 1000;
		setLocalStorageData('logoutTime', expirationTime);
		setLocalStorageData('loginTime', loginTime);

		if (response.data.isPrimaryContact && response.data.customerOnboarded === false) {
			return navigate('/onboarding_system');
		}

		if (response.data.redirectUrl) {
			navigate(response.data.redirectUrl);
		} else {
			navigate(getLocalStorageData('redirect') || '/tickets/');
		}
	} catch (error) {
		dispatch(setSsoLoginFailure(error));
	}
};
// get token from sso authentication

export const SSOAuthToken = token => dispatch => {
	return new Promise((resolve, reject) => {
		API.get(`/auth/sso/signatures?token=${token}`)
			.then(response => {
				resolve(response.data);
			})
			.catch(error => {
				reject(error);
			});
	});
};

// logout
export const logout = async () => async dispatch => {
	// Clear the persisted storage
	try {
		// Clear the IndexedDB instance named "ABC"
		window.indexedDB
			.databases()
			.then(r => {
				for (var i = 0; i < r.length; i++) window.indexedDB.deleteDatabase(r[i].name);
			})
			.then(() => {
				alert('All data cleared.');
			});
		console.log('IndexedDB instance "ABC" cleared successfully.');
	} catch (error) {
		console.error('Error clearing IndexedDB instance:', error);
	}
};

export const getCurrentCompanyToken = (token, refresh, customerID) => async dispatch => {
	try {
		const response = await API.get(`/auth/update_permissions?token=${token}&refresh=${refresh}&customerID=${customerID}`);
		console.log('inResp', {
			token: response?.data?.token,
			refresh: response?.data?.refresh,
		});
		setSessionCookie(response?.data);
		dispatch(loginSuccess(response.data));
	} catch (error) {
		console.log('StatusCode__', error?.response?.status);
	}
};

export const healthCheck = () => async dispatch => {
	try {
		const response = await API.get('/auth/ping');
		console.log('healthCheck', response);
	} catch (error) {
		console.log('StatusCode__', error?.response?.status);
	}
};
